// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function tipulim2_mouseOut(event) {
	//Add your code for this event here:

	$w('#tipulim2').hide() 
}